/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'

import html2canvas from 'html2canvas'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import ReactHtmlParser from 'react-html-parser'
import PushContentToSocialMedia from '../../Services/Mutations/PushContentToSocialMedia'
import { ToastContainer, toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid'
import { pushContentToSocialMedia } from '../../Graphql/mutations'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import axios from 'axios'
import b64toBlob from 'b64-to-blob'
import AwsConfig from '../../Config/AwsConfig'
import CreateTwitterPost from '../../Services/Mutations/CreateTwitterPost'
import Draggable, { DraggableCore } from 'react-draggable'
// import limgg from "./images/v1.jpeg";
// import './highlight.css'

export default function PreviewShareImage(props) {
  const toastStyle = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  console.log(props.multimage, 'multiiiiiiiiiiiiiiiii')
  let imagefinalll
  // const [selectedItem, setSelectedItem] = useState
  const { selectedTheme, data, contentData } = props
  const [twitterImagesArr, setTwitterImages] = useState([])
  console.log(contentData, 'data in preview')
  const [facebook, setFacebook] = useState(true)
  const [instagram, setInstagram] = useState(true)
  const [twitter, setTwitter] = useState(true)
  const [imageurl, setImageurl] = useState()
  const [imageHeight, setImageHeight] = useState()
  const [imageWidth, setImageWidth] = useState()
  // image height and width imghigwid
  // let imgheight
  // let imgwidth
  // const imgRef = useRef();
  // function Loadimgheight() {
  // imgheight=imgRef.current.clientHeight;
  // imgwidth=imgRef.current.clientWidth
  // console.log(imgheight,"/////height///////%%%///////")
  // console.log(imgwidth,"/////width////////////%%%%//")
  // return imgheight
  // }
  // useEffect(() => {
  // if (imgRef.current?.complete) {
  // Loadimgheight();
  // }
  // }, []);

  // end img height and width
  console.log(imageurl, 'this is the image path')
  const renderTextBlock = count => {
    const img = new Image()
    img.onload = function() {
      console.log(this.height, this.width, '................>>>>>>>>')
      const imgheightall = this.height
      const imgwidthall = this.width
      if (imgheightall > imgwidthall) {
        setImageHeight('200')
      } else {
        setImageHeight('130')
      }
    }

    img.src = props.data.image
    console.log(imageHeight, imageWidth, 'imageHeight=====')

    console.log(data, 'here is the count')
    switch (count.noOfTextBlocks) {
      case 11:
        console.log('case 1')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div className='position-relative11' style={{ overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
              <div
                className='descriptionFont12 col'
                style={{
                  height: '27%',
                  color: `${props.color1}`,
                  fontFamily: count.box1FontStyle,
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  backgroundColor: count.box1BackgroundColor,
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>
            </div>
          </div>
        )
        break
      case 1:
        console.log('case 1')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div className='position-relative' style={{ height: '65%', overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={props.data.image}
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>

              <div
                className=' descriptionFont12 '
                style={{
                  height: '27%',
                  color: count.box1FontColor,
                  fontFamily: count.box1FontStyle,
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  backgroundColor: count.box1BackgroundColor,
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>
            </div>
          </div>
        )
        break
      case 2:
        console.log('case 2')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div
                className='titleFont11 pad'
                style={{
                  color: count.titleFontColor,
                  fontFamily: count.titleFontStyle,
                  fontSize: count.titleFontSize,
                  lineHeight: count.titleLineHeight,
                  backgroundColor: count.titleBackgroundColor,
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>
              <div
                className='description1'
                style={{
                  color: count.box1FontColor,
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  fontFamily: count.box1FontStyle,
                  backgroundColor: count.box1BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description)}</div>
              </div>
              <div className='position-relative2' style={{ height: '49%', overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage2'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage2'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
              <div
                className='descriptionFont122 heighlight '
                style={{
                  height: '24%',
                  color: count.box2FontColor,
                  fontSize: count.box2FontSize,
                  lineHeight: count.box2LineHeight,
                  fontFamily: count.box2FontStyle,
                  backgroundColor: count.box2BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description2)}</div>
              </div>
            </div>
          </div>
        )
        break
      case 3:
        console.log('case 3')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div
                className='titleFont03 '
                style={{
                  color: count.titleFontColor,
                  fontFamily: count.titleFontStyle,
                  fontSize: count.titleFontSize,
                  lineHeight: count.titleLineHeight,
                  backgroundColor: count.titleBackgroundColor,
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>

              <div
                className='description13'
                style={{
                  color: count.box1FontColor,
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  fontFamily: count.box1FontStyle,
                  backgroundColor: count.box1BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description)}</div>
              </div>
              <div className='position-relative3' style={{ overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage3'
                    style={{ width: '100%' /* height:`${imageHeight}%` */ }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage2'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
              <div
                className='descriptionFont123'
                style={{
                  color: count.box2FontColor,
                  fontSize: count.box2FontSize,
                  lineHeight: count.box2LineHeight,
                  fontFamily: count.box2FontStyle,
                  backgroundColor: count.box2BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description2)}</div>
              </div>
              <div
                className='descriptionFont1234'
                style={{
                  color: count.box3FontColor,
                  fontSize: count.box3FontSize,
                  lineHeight: count.box3LineHeight,
                  fontFamily: count.box2FontStyle,
                  backgroundColor: count.box3BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description3)}</div>
              </div>
            </div>
          </div>
        )
        break
      case 4:
        console.log('case 4')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: 'black' }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div className='position-relative44' style={{ overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage2'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage2'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
              <div className='disc44 '>
                <div style={{ backgroundColor: 'black', height: '34%' }}>
                  <div
                    className='titleFont11'
                    style={{
                      height: '80%',
                      color: count.titleFontColor,
                      fontFamily: count.titleFontStyle,
                      fontSize: count.titleFontSize,
                      lineHeight: count.titleLineHeight,
                      backgroundColor: 'yellow',
                    }}
                  >
                    {ReactHtmlParser(data.title)}
                  </div>
                </div>

                <div
                  className='discription44'
                  style={{
                    lineHeight: '2.1rem',
                    color: count.box1FontColor,
                    fontSize: count.box1FontSize,
                    fontFamily: count.box1FontStyle,
                    backgroundColor: count.box1BackgroundColor,
                  }}
                >
                  <div> {ReactHtmlParser(data.description)}</div>
                </div>
              </div>
              {/* <div className='descriptionFont123' style={{ color: count.box2FontColor, fontSize: count.box2FontSize, lineHeight: count.box2LineHeight, fontFamily: count.box2FontStyle, backgroundColor: count.box2BackgroundColor }}>
<div>
{data.description2}
</div>
</div>
<div className='descriptionFont1234' style={{ color: count.box3FontColor, fontSize: count.box3FontSize, lineHeight: count.box3LineHeight, fontFamily: count.box3FontStyle, backgroundColor: count.box3BackgroundColor }}>
<div>
{data.description3}
</div>
</div> */}
            </div>
          </div>
        )
        break
      case 5:
        console.log('case 5')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div
                className='descriptionFont5 '
                style={{
                  color: count.box1FontColor,
                  fontFamily: count.box1FontStyle,
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  backgroundColor: count.box1BackgroundColor,
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>
              <div className='position-relative' style={{ overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
            </div>
          </div>
        )
        break
      case 6:
        console.log('case 6')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: 'black' }}
            >
              <Draggable>
                <img
                  className='headImage'
                  src='dist/img/YousayStrip.jpeg'
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div
                className='titlecase6 '
                style={{
                  color: 'yellow',
                  fontFamily: count.box1FontStyle,
                  fontSize: '23px',
                  lineHeight: count.box1LineHeight,
                  backgroundColor: 'black',
                }}
              >
                {ReactHtmlParser(data.title)}
              </div>
              <div
                className='description60'
                style={{
                  color: 'white',
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  fontFamily: count.box1FontStyle,
                  backgroundColor: 'black',
                }}
              >
                <div> {ReactHtmlParser(data.description)}</div>
              </div>

              <div className='position-relative2' style={{ height: '47%', overflow: 'hidden' }}>
                <Draggable>
                  <img
                    className='mainImage2 start6'
                    style={{ width: '100%', height: `${imageHeight}%` }}
                    src={
                      props.defaultimg
                        ? props.data.image
                        : props.mimages
                        ? props.mimages[0]
                          ? props.mimages[0].image
                          : null
                        : null
                    }
                    alt='Girl in a jacket'
                    width='500'
                    height='600'
                  />
                </Draggable>
                <Draggable>
                  <img
                    className='position-absoluteImage2'
                    src='dist/img/YousayLogo.jpeg'
                    alt='Girl in a jacket'
                  />
                </Draggable>
              </div>
              <div
                className='description61'
                style={{
                  color: 'yellow',
                  fontSize: count.box1FontSize,
                  lineHeight: count.box1LineHeight,
                  fontFamily: count.box1FontStyle,
                  backgroundColor: 'black',
                }}
              >
                <div> {ReactHtmlParser(data.description2)}</div>
              </div>
              <div
                className='descriptionFont162'
                style={{
                  color: 'white',
                  fontSize: count.box2FontSize,
                  lineHeight: count.box3LineHeight,
                  fontFamily: count.box2FontStyle,
                  backgroundColor: count.box2BackgroundColor,
                }}
              >
                <div> {ReactHtmlParser(data.description3)}</div>
              </div>
            </div>
          </div>
        )
        break
      default:
        console.log('case default')
        return (
          <div className='htmlToCanvasVis'>
            <div
              className={`shareCard shareCardPreview ${
                selectedTheme.themeName === count.themeName ? 'selectedTheme' : ''
              } d-flex justify-content-center align-counts-center`}
              style={{ backgroundColor: count.titleBackgroundColor }}
            >
              <Draggable>
                <img
                  className='shareImageSample'
                  src={data.image}
                  alt='Girl in a jacket'
                  width='500'
                  height='600'
                />
              </Draggable>
              <div
                className='descriptionFont1'
                style={{
                  color: count[`box${count.noOfTextBlocks}FontColor`],
                  box2FontSize: count[`box${count.noOfTextBlocks}box2FontSize`],
                  box2LineHeight: count[`box${count.noOfTextBlocks}box2LineHeight`],
                  backgroundColor: `${count[`box${count.noOfTextBlocks}BackgroundColor`]}`,
                }}
              >
                {data.title}
              </div>
            </div>
          </div>
        )
    }
  }

  const toggleFacebook = () => {
    setFacebook(!facebook)
    console.log('this is the facebook log')
  }

  const toggleInstagram = () => {
    setInstagram(!instagram)
    console.log('this is the setInstagram log')
  }

  const toggleTwitter = () => {
    setTwitter(!twitter)
    console.log('this is the toggleTwitter log')
  }

  // const GetDate = () => {
  // return (
  // new Date().getFullYear() +
  // '' +
  // ('0' + (new Date().getMonth() + 1)).slice(-2) +
  // ('0' + new Date().getDate()).slice(-2)
  // )
  // }

  const postToSocialMedia = async () => {
    console.log(props.disableTandD, 'props.disableTandD======')
    if (props.disableTandD) {
      const twitterImages = props.selectedImages.map(item => item.image)

      var data = document.getElementsByClassName('shareCardPreview')
      console.log(data, 'here is the data')
      for (var i = 0; i < data.length; ++i) {
        html2canvas(data[i], {
          // when we connect to VPN we cannot download image
          useCORS: true,
          proxy: true,
          allowTaint: true,
        }).then(canvas => {
          const image = canvas.toDataURL('image/png')
          // setImageurl(image);
          const key = image
          console.log(key, 'key================')
          const ImagesArr = []
          twitterImages.push(key)

          const filteredTwitterImagesArr = twitterImages.filter(
            (item, index) => item !== props.image,
          )
          console.log(
            filteredTwitterImagesArr,
            props.image,
            twitterImages,
            'selectedimageeeeeeeeeeeeeeeeeee===',
          )
          console.log(filteredTwitterImagesArr, 'filteredTwitterImagesArr1111')
          filteredTwitterImagesArr.map((twitterImage, twitterIndex) => {
            urltoFile(twitterImage, 'abc.png', 'image/png').then(async file => {
              console.log(file, 'here is the file data')
              const randomId = await uuidv4()
              console.log(randomId, 'randomId123333')
              const key = randomId.replaceAll('-', '') + '.jpeg'
              console.log(key, 'first keyy1111')
              const params = {
                key,
                mimeType: file.type,
                type: 'ktsocialmedia',
              }
              const preSignedURLObject = await getPreSignedURLForImageService(params)
              const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
              const signedURL = signedURLObject.data.url
              try {
                const formData = new FormData()
                Object.keys(signedURLObject.data.fields).forEach(key => {
                  formData.append(key, signedURLObject.data.fields[key])
                })
                // Actual file has to be appended last.

                formData.append('file', file)
                console.log(signedURL, 'signedURL================')
                const response = await axios({
                  method: 'post',
                  url: signedURL,
                  data: formData,
                  headers: { 'Content-Type': 'multipart/form-data' },
                })
                console.log(response, 'this is the response')
              } catch (err) {
                console.warn(err, 'err')
              }

              // saveAs(image, 'exported-vis.png'
              const s3Url = AwsConfig.s3ObjectUrl
              console.log(key, 'key123zz')
              let finalImage = key ? key : ''
              if (finalImage && !finalImage.includes(s3Url)) {
                finalImage = s3Url + key

                console.log(s3Url, 's333333333333')
                console.log(finalImage, 'here is the final image')
                // ImagesArr.push(finalImage)
                ImagesArr.splice(0, 0, finalImage)
                console.log(ImagesArr, 'ImagesArr======')

                const PreviewShareImageimgobj = { PreviewShareImageimg }
                const selectedImagesprops = props.selectedImages
                selectedImagesprops.splice(0, 0, PreviewShareImageimgobj.PreviewShareImageimg)
                console.log(PreviewShareImageimg, 'PreviewShareImageimgPreviewShareImageimg45t')
                console.log(selectedImagesprops, 'selectedImagesprops656')
                if (ImagesArr.length === filteredTwitterImagesArr.length) {
                  console.log(twitter, 'twitter=============')
                  if (twitter) {
                    const input = {
                      title: props.data.socialMediaDes,
                      // contentID: contentData.PK,
                      urls: ImagesArr.map(item => item),
                      // url: finalImage,
                    }
                    console.log(input, 'input=======')

                    console.log(input, 'this is the input for twitter share')
                    const twitter_response = await CreateTwitterPost(input)
                    console.log(twitter_response, 'here is the data response for twitter share')
                    switch (twitter_response && twitter_response.statusCode) {
                      case 'A200':
                        toast.success('Tweet Posted Successfully', toastStyle)
                        break
                      case 'A380':
                        toast.success('Posted to Twitter Successfully', toastStyle)
                        break
                      case 'A381':
                        toast.error('Failed to Post in Twitter ', toastStyle)
                        break
                      case 'A382':
                        toast.success('Multiple Images Posted in Twitter Successfully ', toastStyle)
                        break
                      default:
                        toast.error('Failed to Post in Twitter', toastStyle)
                    }
                  }
                }
              }
            })
          })

          console.log(twitterImages, 'twitterImagestwitterImages')
        })
      }
    } else {
      const twitterImages = props.selectedImages.map(item => item.image)
      console.log(props.defaultimg, 'defaultimg=================')
      console.log(twitterImages, 'twitterImages======================')
      console.log('inside else condition==============')
      const ImagesArr = []

      // let ImagesArr11 = ["https://ktree-vidapp.s3.ap-south-1.amazonaws.com/public/motvtnl5.jpg", "https://ktree-vidapp.s3.ap-south-1.amazonaws.com/public/motvtnl6.jpg", "https://ktree-vidapp.s3.ap-south-1.amazonaws.com/public/motvtnl7.jpg", "https://ktree-vidapp.s3.ap-south-1.amazonaws.com/public/motvtnl8.jpg"]
      twitterImages.map((twitterImage, twitterIndex) => {
        urltoFile(twitterImage, 'abc.png', 'image/png').then(async file => {
          console.log(file, 'here is the file data')
          const randomId = await uuidv4()
          const key = randomId.replaceAll('-', '') + '.jpeg'
          const params = {
            key,
            mimeType: file.type,
            type: 'ktsocialmedia',
          }
          const preSignedURLObject = await getPreSignedURLForImageService(params)
          const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
          const signedURL = signedURLObject.data.url
          try {
            const formData = new FormData()
            Object.keys(signedURLObject.data.fields).forEach(key => {
              formData.append(key, signedURLObject.data.fields[key])
            })
            // Actual file has to be appended last.

            formData.append('file', file)

            const response = await axios({
              method: 'post',
              url: signedURL,
              data: formData,
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            console.log(response, 'this is the response')
          } catch (err) {
            console.warn(err, 'err')
          }

          // saveAs(image, 'exported-vis.png'
          const s3Url = AwsConfig.s3ObjectUrl
          let finalImage = key ? key : ''
          if (finalImage && !finalImage.includes(s3Url)) {
            finalImage = s3Url + key
            console.log(finalImage, 'here is the final image')
            ImagesArr.unshift(finalImage)
            console.log(ImagesArr, 'ImagesArr======')
            // let selectedImagesprops= props.selectedImages
            // selectedImagesprops.unShift(PreviewShareImageimg)
            if (ImagesArr.length == twitterImages.length) {
              console.log(twitter, 'twitter=============')
              if (twitter) {
                const input = {
                  title: props.data.socialMediaDes,
                  // contentID: contentData.PK,
                  urls: ImagesArr.map(item => item),
                  // url: finalImage,
                }
                console.log(input, 'input====================')

                console.log(input, 'this is the input for twitter share')
                const data = await CreateTwitterPost(input)
                console.log(data, 'here is the data response for twitter share')
                switch (data.statusCode) {
                  case 'A200':
                    toast.success('Tweet Posted Successfully', toastStyle)
                    break
                  case 'A380':
                    toast.success('Posted to Twitter Successfully', toastStyle)
                    break
                  case 'A381':
                    toast.error('Failed to Post in Twitter ', toastStyle)
                    break
                  case 'A382':
                    toast.success('Multiple Images Posted in Twitter Successfully ', toastStyle)
                    break
                  default:
                    toast.error('Failed to Post in Twitter', toastStyle)
                }
              }
            }
          }
        })
      })
    }

    var data = document.getElementsByClassName('shareCardPreview')
    console.log(data, 'here is the data')
    for (var i = 0; i < data.length; ++i) {
      html2canvas(data[i], {
        // when we connect to VPN we cannot download image
        useCORS: true,
        proxy: true,
        allowTaint: true,
      }).then(canvas => {
        const image = canvas.toDataURL('image/png')
        // setImageurl(image);
        const key = image
        urltoFile(key, 'abc.png', 'image/png').then(async file => {
          console.log(file, 'here is the file data')
          const randomId = await uuidv4()
          const key = randomId.replaceAll('-', '') + '.jpeg'
          const params = {
            key,
            mimeType: file.type,
            type: 'ktsocialmedia',
          }
          console.log(params, 'params====================')
          const preSignedURLObject = await getPreSignedURLForImageService(params)
          const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
          const signedURL = signedURLObject.data.url
          try {
            const formData = new FormData()
            Object.keys(signedURLObject.data.fields).forEach(key => {
              formData.append(key, signedURLObject.data.fields[key])
            })
            // Actual file has to be appended last.

            formData.append('file', file)

            const response = await axios({
              method: 'post',
              url: signedURL,
              data: formData,
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            console.log(response, 'this is the response=====================================')
          } catch (err) {
            console.warn(err, 'err')
          }

          console.log(image, 'this is imageuri')
          // saveAs(image, 'exported-vis.png'
          const s3Url = AwsConfig.s3ObjectUrl
          let finalImage = key ? key : ''
          if (finalImage && !finalImage.includes(s3Url)) {
            finalImage = s3Url + key
            console.log(finalImage, 'here is the final image')
          }

          const input = {
            facebook,
            instagram,
            url: finalImage,
            message: props.data.socialMediaDes,
          }
          console.log(input, 'input')

          const instagram_data = await PushContentToSocialMedia(input)
          console.log(instagram_data, 'instagram_data from service')
          switch (instagram_data.statusCode) {
            case 'A368':
              toast.success('Posted Successfully in both instagram and facebook', toastStyle)
              break
            case 'A369':
              toast.success('Posted Successfully in facebook ', toastStyle)
              toast.error('Failed to post in instagram', toastStyle)
              break
            case 'A370':
              toast.success('Posted Successfully in facebook ', toastStyle)
              toast.error("Instagram Token doesn't exist", toastStyle)
              break
            case 'A371':
              toast.success('Posted Successfully in Instagram ', toastStyle)
              toast.error(' Failed to post in facebook', toastStyle)
              break
            case 'A372':
              toast.error('Failed to post in facebook and Instagram', toastStyle)
              break
            case 'A373':
              toast.error("Failed to post in Facebook, Instagram Tokens doesn't Exist", toastStyle)
              break
            case 'A374':
              toast.success('Posted Successfully in instagram ', toastStyle)
              toast.error('Failed to post in facebook', toastStyle)
              break
            case 'A375':
              toast.success('Failed to post in Facebook and Instagram', toastStyle)
              break
            case 'A376':
              toast.error('Facebook and Instagram Tokens are Expired', toastStyle)
              break
            default:
              toast.error('Failed to Post ', toastStyle)
          }
        })
      })
    }
  }

  function urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(res => res.arrayBuffer())
      .then(buf => new File([buf], filename, { type: mimeType }))
  }

  const [PreviewShareImageimg, setPreviewShareImageimg] = useState()
  const exportAsPicture = () => {
    console.log('hello btn')
    if (contentData) {
      let lang = 'En'
      if (contentData.contentLanguages) {
        lang = contentData.contentLanguages.includes('En') ? 'En' : 'Te'
      }

      const { storyDetails } = contentData?.contentMetaInfo
      const storyTitle = storyDetails[`storyTitle_${lang}`]
      const storyCardDescription = storyDetails[`storyCardDescription_${lang}`]
      // {
      // html2canvas(document.getElementsByClassName('htmlToCanvasVis'), {
      // //when we connect to VPN we cannot download image
      // useCORS: true, proxy: true, allowTaint: true,
      // }).then(function (canvas) {
      // var imageURL = canvas.toDataURL('image/png')
      // console.log(imageURL, 'here is the image URL');
      // let a = document.createElement('a')
      // a.href = imageURL
      // a.download = 'storyTitle.jpg'
      // a.click()
      // })
      // }

      const data = document.getElementsByClassName('shareCardPreview')
      console.log(data, 'here is the data')
      for (let i = 0; i < data.length; ++i) {
        html2canvas(data[i], {
          // when we connect to VPN we cannot download image
          useCORS: true,
          proxy: true,
          allowTaint: true,
        }).then(canvas => {
          const image = canvas.toDataURL('image/png')
          setImageurl(image)
          setPreviewShareImageimg(image)
          console.log(image, 'this is imageuri')
          console.log(PreviewShareImageimg, 'PreviewShareImageimg767')
          // saveAs(image, 'exported-vis.png')
          const a = document.createElement('a')
          a.href = image
          a.download = 'storyTitle.jpg'
          a.click()
        })
      }

      toast.success('Image Downloaded Successfully')
    }
  }

  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className='preview-share'>
        {/* <div>PreviewShareImage</div> */}
        {renderTextBlock(selectedTheme)}
        <div className='downloadbutton'>
          {/* whenever user clicks on the download image button the image should be downloaded */}
          <button onClick={exportAsPicture} type='button' className='btn btn-primary'>
            Download Image
          </button>
        </div>
      </div>
      <div className='toogle d-flex justify-content-between p-2'>
        <div>
          <label className='switch'>
            <input
              type='checkbox'
              className='faceBook'
              onClick={toggleFacebook}
              checked={facebook}
            ></input>
            <span className='slider round'></span>
          </label>
          <text>{'Facebook'}</text>
        </div>
        <div>
          <label className='switch'>
            <input
              type='checkbox'
              className='insta333'
              onClick={toggleInstagram}
              checked={instagram}
            ></input>
            <span className='slider round'></span>
          </label>
          <text>{'Instagram'}</text>
        </div>
        <div>
          <label className='switch'>
            <input type='checkbox' onClick={toggleTwitter} checked={twitter}></input>
            <span className='slider round'></span>
          </label>
          <text>{'Twitter'}</text>
        </div>
      </div>
      <div className='share'>
        <button
          onClick={postToSocialMedia}
          type='button'
          className='btn btn-primary'
          disabled={Boolean(data.socialMediaDes?.length > 256 || !props.no_ofSelectedimagesT_F)}
        >
          Share
        </button>
      </div>
    </>
  )
}
